{
  "new_round": "New Round",
  "creating_round": "Creating round...",
  "golf_round": "Golf Round",
  "score": "Score",
  "holes": "holes",
  "holes_played": "holes played",
  "active_status": "Active",
  "completed_status": "Completed",
  "abandoned_status": "Abandoned",
  "failed_to_load_rounds": "Failed to load rounds",
  "failed_to_create_new_round": "Failed to create new round",
  "failed_to_load_active_round": "Failed to load active round",
  "round": "Round",
  "new_round_started": "New round started!",
  "failed_to_create_round": "Failed to create new round",
  "round_completed": "Round completed!",
  "round_completed_and_submitted_to_competitions": "Round completed and submitted to {{count}} weekly competition(s)!",
  "round_completed_but_submission_failed": "Round completed but submission to weekly competitions failed",
  "failed_to_complete_round": "Failed to complete round",
  "are_you_sure_abandon_round": "Are you sure you want to abandon this round?",
  "round_abandoned": "Round abandoned",
  "failed_to_abandon_round": "Failed to abandon round",
  "abandon": "Abandon",
  "abandon_round": "Abandon",
  "delete_round": "Delete Round",
  "delete_round_confirm_title": "Delete Round",
  "delete_round_confirm_message": "Are you sure you want to delete '{{roundName}}'? This action cannot be undone.",
  "round_deleted_successfully": "Round deleted successfully",
  "failed_to_delete_round": "Failed to delete round",
  "delete_not_supported_yet": "Delete functionality is not yet available on the server",
  "complete": "Complete",
  "complete_round": "Complete",
  "are_you_sure_complete_round": "Are you sure you want to complete this round?",
  "pause": "Pause",
  "pause_round": "Pause",
  "are_you_sure_pause_round": "Are you sure you want to pause this round? You can resume it later.",
  "round_paused": "Round paused successfully!",
  "failed_to_pause_round": "Failed to pause round",
  "round_management": "Round Management",
  "hole": "Hole",
  "failed_to_update_score": "Failed to update score",
  "failed_to_mark_picked_up": "Failed to mark as picked up",
  "picked_up": "Picked up",
  "failed_to_clear_score": "Failed to clear score",
  "scorecard": "Scorecard",
  "current_hole": "Current Hole",
  "out": "Out",
  "in": "In",
  "tot": "Tot",
  "par": "Par",
  "handicap_index": "Handicap Index",
  "playing_handicap": "Playing Handicap",
  "course": "Course",
  "start_round": "Start Round",
  "select_course_and_tee": "Select Course & Tee",
  "search_courses": "Search courses...",
  "select_course": "Select course",
  "recent_courses": "Recent courses",
  "no_courses_found": "No courses found",
  "no_courses_available": "No courses available",
  "select_tee_set": "Select tee",
  "failed_to_load_courses": "Failed to load courses",
  "failed_to_load_course_details": "Failed to load course details",
  "scorecard_view": {
    "scorecard_not_found": "Scorecard Not Found",
    "scorecard_not_found_subtitle": "The requested scorecard could not be loaded",
    "scorecard_not_found_message": "This scorecard may have been deleted or you may not have permission to view it.",
    "back_to_dashboard": "Back to dashboard",
    "back": "Back",
    "date_played": "Date Played",
    "notes": "Notes",
    "length": "Length",
    "hcp": "HCP",
    "score": "Score",
    "par": "Par",
    "hole": "Hole",
    "golf_course": "Golf Course",
    "no_scorecard_data": "No scorecard data available",
    "failed_to_load_scorecard": "Failed to load scorecard",
    "strokes": "Strokes",
    "hole_disabled": "Hole is not in use for this round",
    "pituus": "Length",
    "delete_round": {
      "section_title": "Delete Round",
      "button_label": "Delete Round",
      "modal_title": "Delete Round",
      "modal_body": "Are you sure you want to delete this round? The round will be permanently removed from your statistics and this action cannot be undone.",
      "modal_confirm": "Delete Round",
      "modal_cancel": "Cancel"
    },
    "share": "Share",
    "share_preview_title": "Share scorecard",
    "share_recommended": "Recommended sharing method",
    "share_variant_feed": "Instagram and Facebook feed",
    "share_variant_story": "Instagram story",
    "share_title": "My golf round",
    "share_text": "{{course}} — {{score}} ({{date}})",
    "share_failed": "Failed to share image"
  },
  "conditions": {
    "optional_conditions": "Conditions",
    "weather": "Weather",
    "weather_sunny": "Sunny",
    "weather_cloudy": "Cloudy",
    "weather_light_rain": "Light Rain",
    "weather_heavy_rain": "Heavy Rain",
    "weather_light_wind": "Light Wind",
    "weather_strong_wind": "Strong Wind",
    "pin_placement": "Pin Placement",
    "pin_easy": "Easy",
    "pin_average": "Average",
    "pin_hard": "Hard",
    "green_pace": "Green Pace",
    "pace_slow": "Slow",
    "pace_average": "Average",
    "pace_fast": "Fast",
    "green_hardness": "Green Hardness",
    "hardness_soft": "Soft",
    "hardness_average": "Average",
    "hardness_hard": "Hard",
    "comment": "Additional Notes",
    "temperature": "Temperature",
    "wind_speed": "Wind speed",
    "add_conditions": "Add conditions",
    "updated_successfully": "Conditions updated successfully",
    "update_failed": "Failed to update conditions",
    "no_comment": "No additional information",
    "set_conditions": "Set",
    "comment_placeholder": "Write a comment"
  },
  "cr": "CR",
  "slope": "Slope",
  "tee": "Tee",
  "total": "Total",
  "net_total": "Net Score",
  "tee_selection": "Tee",
  "handicap": "Handicap",
  "handicap_abbr": "HCP",
  "quick_hole_nav": "Go to hole",
  "starting_hole": "Starting hole",
  "starting_hole_help": "Select the hole where you start your round",
  "front_nine": "Holes 1-9",
  "back_nine": "Holes 10-18",
  "private_round": "Private round",
  "private_round_description": "Round will not be visible to your friends",
  "private": "Private",
  "distance_unit": "Distance unit",
  "distance_unit_help": "Select the unit for entering fairway distances",
  "handicap_factor": "Handicap Factor",
  "round_started_with_competitions": "New round started for the weekly competition!",
  "start_round_v2": "Start Round (V2)",
  "course_and_tee": "Course and Tee",
  "played_date": "Played",
  "round_actions": {
    "title": "Do you want to end the round?",
    "complete": "Complete Round",
    "pause": "Save and Continue Later",
    "delete": "Delete Round",
    "close": "Close"
  },
  "hole_status": {
    "completed": "Played",
    "current": "Current",
    "not_played": "Not Played",
    "picked_up": "Picked Up"
  },
  "round_result_confirmation": {
    "title": "Confirm Round Result",
    "round_information": "Round Information",
    "player_name": "Player",
    "exact_handicap": "Handicap",
    "course_name": "Course",
    "tee_name": "Tee",
    "course_rating": "CR",
    "slope_rating": "Slope",
    "playing_handicap": "Playing Handicap",
    "scorecard": "Scorecard",
    "gross_total": "Total Strokes (gross)",
    "net_total": "Net Score",
    "confirmation_message": "Review the details and confirm the round result. After confirmation, you can enter course conditions.",
    "accept": "Confirm Result"
  },
  "statistics": {
    "title": "Statistics",
    "track_stats": "Statistics enabled",
    "track_stats_description": "Record shot statistics for this round",
    "hole_statistics": "Hole Statistics",
    "save": "Save",
    "tee_shot": "Tee Shot",
    "fairway": "Fairway Hit",
    "fairway_center": "Center",
    "fairway_right": "Right",
    "fairway_left": "Left",
    "fairway_short": "Short",
    "fairway_long": "Long",
    "approach": "Approach",
    "green": "Green Hit",
    "green_hit": "Hit",
    "green_right": "Right",
    "green_left": "Left",
    "green_short": "Short",
    "green_long": "Long",
    "short_game": "Short Game",
    "putts": "Putts",
    "chips": "Chips",
    "bunker_shots": "Bunker shots",
    "penalties": "Penalties",
    "putting": "Putting",
    "first_putt_length": "First Putt",
    "sunk_putt_length": "Sunk Putt",
    "meters": "meters",
    "first_putt_not_set": "Not Set",
    "first_putt_under_3m": "Under 3 meters",
    "first_putt_3_5m": "3-5 meters",
    "first_putt_5_10m": "5-10 meters",
    "first_putt_10_20m": "10-20 meters",
    "first_putt_over_20m": "Over 20 meters",
    "saves": "Saves",
    "up_and_down": "Up & Down",
    "sand_save": "Sand Save",
    "fairway_hits": "Fairways in Regulation",
    "green_hits": "Greens in Regulation",
    "avg_putts": "Avg Putts",
    "avg_putt_distance": "Avg Putt Distance (m)",
    "no_data": "No statistics",
    "stats_saved": "Statistics saved",
    "stats_deleted": "Statistics deleted",
    "failed_to_save_stats": "Failed to save statistics",
    "failed_to_delete_stats": "Failed to delete statistics",
    "clear_stats": "Clear",
    "par3_no_fairway": "Fairway statistics are not tracked for par 3 holes",
    "par3_no_green": "Green statistics are not tracked for par 3 holes",
    "stats_reminder_title": "Statistics Missing",
    "stats_reminder_message": "You haven't saved statistics for this hole. Would you like to add them now?",
    "add_stats": "Add Statistics",
    "skip_stats": "Skip",
    "round_stats": "Round Statistics",
    "fir": "FIR",
    "gir": "GIR",
    "ppg": "PPG",
    "fairways_caption": "Fairways",
    "greens_caption": "Greens",
    "putts_per_hole": "Putts per hole",
    "first_putt_avg": "1st putt avg. (m)"
  },
  "handicap_round": {
    "toggle": "Handicap Round",
    "marker_name": "Marker Name",
    "info": "The result will be submitted to eBirdie as a handicap round",
    "info_competition": "The score will be reported to eBirdie as a competition round",
    "marker_label": "Marker",
    "marker_required": "Marker's name is required to submit the score to eBirdie"
  },
  "unit_suffix": {
    "metric": "m",
    "imperial": "y"
  },
  "units": {
    "meters": "Meters",
    "yards": "Yards"
  },
  "hole_scores": "Hole Scores",
  "hcp_badge": "HCP",
  "round_finalize": {
    "save_round": "Save round",
    "back_to_scoring": "Back to scoring",
    "handicap_update_failed": "Error saving handicap round",
    "marker_required_warning": "Enter marker's name to submit the round to eBirdie"
  },
  "played_date_edit_title": "Round Date",
  "played_date_updated_successfully": "Round date updated successfully",
  "played_date_update_failed": "Round date update failed",
  "start_round_pay_required": "Proceed to payment",
  "start_round_pay_voluntary": "Continue",
  "nearest_courses": "Nearest courses",
  "all_courses": "All courses",
  "record_round_title": "Record Round",
  "record_round_subtitle": "Fill in the details and proceed to the scorecard to enter your scores.",
  "desktop_scorecard": {
    "score": "Score",
    "net": "Net",
    "points": "Points",
    "total": "Total"
  },
  "continue_to_scorecard": "Continue to Scorecard",
  "multiplayer": {
    "players_title": "Players",
    "add_players": "Add players",
    "add_players_description": "Keep a scorecard for the whole group",
    "tab_ebirdie": "eBirdie",
    "tab_friends": "Friends",
    "tab_manual": "Other",
    "search_title": "Search eBirdie",
    "search_placeholder": "Name or member number",
    "search_club": "Club",
    "search_button": "Search player",
    "search_results_title": "Search results",
    "search_no_results": "No results found",
    "add": "Add",
    "manual_title": "Add manually",
    "first_name": "First name",
    "last_name": "Last name",
    "handicap": "Handicap",
    "gender": "Gender",
    "add_player": "Add player",
    "settings_title": "Player settings",
    "name": "Name",
    "tee": "Tee",
    "save": "Save",
    "remove_player": "Remove player",
    "close": "Close",
    "next": "Next",
    "create_round": "Create round",
    "group_created": "Group round created",
    "max_players": "You can add a maximum of three players",
    "already_added": "Player has already been added",
    "scr": "SCR",
    "result": "Score",
    "host_scores_hint": "Only the round host can enter scores",
    "group_section_title": "Group round",
    "abandon_confirm_title": "Abandon group round?",
    "abandon_confirm_body": "The round will end for all players in the group and cannot be continued. This cannot be undone.",
    "game": {
      "step_title": "Game format",
      "format": {
        "skins": "Skins",
        "stroke_play_abbr": "SP",
        "stableford_abbr": "STB",
        "max_score_abbr": "MAX",
        "best_ball_abbr": "BB",
        "skins_abbr": "S"
      },
      "select": "Select",
      "selected": "Selected",
      "coming_soon": "Coming soon",
      "coefficient_label": "Handicap coefficient",
      "handicap_percent": {
        "scratch": "Scratch",
        "twenty_five": "25%",
        "fifty": "50%",
        "seventy_five": "75 %",
        "hundred": "100 %"
      },
      "change_action": "Edit game settings",
      "change_title": "Change game",
      "save": "Save",
      "cancel": "Cancel",
      "change_failed": "Changing the game failed",
      "best_ball_requires_four": "Requires 4 players"
    },
    "teams": {
      "own_team": "My team",
      "choose_partner": "Choose teammate",
      "add_partner": "Select as partner",
      "remove_partner": "Remove partner",
      "team1": "Team 1",
      "team2": "Team 2"
    },
    "leaderboard": {
      "thru": "THRU",
      "gross": "TOT",
      "to_par": "PAR",
      "points": "PTS",
      "net": "NET",
      "failed_to_load": "Failed to load leaderboard",
      "team": "Team {{number}}"
    }
  }
}
